import { useCallback, useEffect, useState } from "react";

export function usePrint() {
	const [printing, setPrinting] = useState(false);

	useEffect(() => {
		if (!printing) return;
		function done() {
			setPrinting(false);
		}
		window.addEventListener("afterprint", done);
		let inner = 0;
		const outer = requestAnimationFrame(() => {
			inner = requestAnimationFrame(() => window.print());
		});
		return () => {
			cancelAnimationFrame(outer);
			cancelAnimationFrame(inner);
			window.removeEventListener("afterprint", done);
		};
	}, [printing]);

	const print = useCallback(() => setPrinting(true), []);

	return { printing, print };
}
